import React, { useEffect, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';

const SearchBar = (props: any) => {
  const { onChange, placeholder, styleType } = props;

  const [isActive, setActive] = useState(false);
  const [queryString, setQueryString] = useState(props.queryString || '');

  const clearSearch = (e: any) => {
    e.stopPropagation();
    setQueryString('');
    onChange('');
  };

  const onTextChange = (e: any) => {
    const newQueryString = e.target.value;
    setQueryString(newQueryString);
    onChange(newQueryString);
  };

  useEffect(() => {
    setQueryString(props.queryString || '');
  }, [props.queryString]);

  return (
    <div
      className={classNames(
        `flex relative flex-auto min-w-min items-center border border-solid bg-white text-neutral-gray-500 rounded-full box-border${
          isActive
            ? ' border-black text-black'
            : ' text-black border-neutral-300'
        }`,
        styleType === 'borderless' ? 'border-none' : '',
      )}
    >
      <div className="pl-4 pr-3">
        <Icon iconName="search" size={20} image />
      </div>
      <input
        className="w-full h-5 my-2 mr-1 ml-0 p-0 border-0 font-sans text-sm focus:outline-none text-black placeholder:text-neutral-gray-500 bg-transparent"
        data-cy="search-input"
        type="text"
        value={queryString}
        placeholder={placeholder}
        onChange={onTextChange}
        onFocus={() => setActive(true)}
        onBlur={() => setActive(false)}
      />
      {queryString && (
        <div
          className="cursor-pointer pr-3"
          onClick={clearSearch}
          data-cy="clear-search"
        >
          <Icon iconName="x" size={10} />
        </div>
      )}
    </div>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  styleType: PropTypes.string,
  queryString: PropTypes.string,
};

SearchBar.defaultProps = {
  placeholder: 'Search...',
  onChange: () => {},
  styleType: 'default',
  queryString: '',
};

export default SearchBar;
